import { render, staticRenderFns } from "./stockproductdailyprice.vue?vue&type=template&id=0a6aca2d&scoped=true&"
import script from "./stockproductdailyprice.vue?vue&type=script&lang=js&"
export * from "./stockproductdailyprice.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./stockproductdailyprice.vue?vue&type=style&index=1&id=0a6aca2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6aca2d",
  null
  
)

export default component.exports